/** CSS variables for the Roleplay service's visual theme. */
export const theme = {
  '--basefont': '"Inter", sans-serif',
  '--primary-darken': 'var(--nice-blue)',
  '--primary': '#007eff' /* variable semantica para color corporativo */,
  '--charcoal-grey': 'var(--charcoal-grey)',
  '--roleplay-black': 'var(--charcoal-grey)',
  '--roleplay-blue': '#007eff',
  '--roleplay-blue-dark': '#0f51b2'
};
